import { debounceEmailBriteVerifyAction } from 'sharedActions/sharedActions';
import { mapDispatchToPropsEmail } from 'reg_redesign/redux/connectFunctions';
import BasicInput from '@opploans/basic-input-component/BasicInput';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';
import PhoneNumberMask from 'components/rebrand/PhoneNumberMask';
import React from 'react';
import RebrandTooltip from 'components/rebrand/RebrandTooltip';

const tooltipText =
  'Email provided will be used as your username to login to your account and check the status of your application.';

const toolTip = () => (
  <RebrandTooltip
    additionalStyle={{ marginTop: '0.25rem !important' }}
    text={tooltipText}
  />
);

const page3 = {
  defaultNextPage: 'page-3.1',
  content: [
    configureProgressBar(6),
    configureTitle([
      'Great to meet you, {{firstName}}.',
      'How can we best contact you?'
    ]),
    {
      component: BasicInput,
      dispatchOverride: mapDispatchToPropsEmail,
      props: {
        id: 'email',
        label: 'Email',
        type: 'text',
        TooltipComponent: toolTip,
        formControlStyle: {
          marginBottom: '1.5rem'
        },
        onChange: debounceEmailBriteVerifyAction,
        onMount: debounceEmailBriteVerifyAction
      }
    },
    {
      component: BasicInput,
      name: 'primaryPhoneNumber',
      props: {
        id: 'primaryPhoneNumber',
        label: 'Primary Phone Number',
        type: 'tel',
        formControlStyle: {
          marginBottom: '1.5rem'
        },
        InputProps: {
          inputComponent: PhoneNumberMask
        }
      }
    },
    {
      component: BasicInput,
      name: 'secondaryPhoneNumber',
      props: {
        id: 'secondaryPhoneNumber',
        label: 'Secondary Phone Number (optional)',
        type: 'tel',
        InputProps: {
          inputComponent: PhoneNumberMask
        }
      }
    },
    nextButtonConfig('page-3')
  ]
};

export default page3;
